import * as yup from 'yup';

export const passwordValidation = yup.object({
    oldPassword: yup.string().required('Old Password is required'),
    newPassword: yup.string().required('New Password is required'),
    confirmNewPassword: yup.string().required('Confirm Password is required').oneOf([yup.ref('newPassword'), null], 'Passwords must match'),
})
